export default {
  "action.add": "24x24",
  "action.add-circle": "24x24",
  "action.checkbox-checked": "24x24",
  "action.checkbox-unchecked": "24x24",
  "action.clear": "24x24",
  "action.close": "24x24",
  "action.copy": "24x24",
  "action.download": "24x24",
  "action.dropper": "24x24",
  "action.edit": "24x24",
  "action.expand": "24x24",
  "action.external-link": "24x24",
  "action.filter": "24x24",
  "action.link": "24x24",
  "action.logout": "24x24",
  "action.maximize": "24x24",
  "action.minimize": "24x24",
  "action.play": "24x24",
  "action.pause": "24x24",
  "action.radio-deselected": "24x24",
  "action.radio-selected": "24x24",
  "action.reorder": "24x24",
  "action.table-sort-ascending": "24x24",
  "action.table-sort-descending": "24x24",
  "action.trash": "24x24",
  "action.copy-to": "24x24",
  "action.move-to": "24x24",
  "action.add-to": "24x24",
  "action.drag-handler": "24x24",
  "action.checkbox-indeterminate": "24x24",
  "action.quick-action": "24x24",
  "action.remove-note": "24x24",
  "action.add-note": "24x24",
  "action.revert": "24x24",
  "action.add_16": "16x16",
  "action.add-circle_16": "16x16",
  "action.checkbox-checked_16": "16x16",
  "action.checkbox-unchecked_16": "16x16",
  "action.clear_16": "16x16",
  "action.close_16": "16x16",
  "action.copy_16": "16x16",
  "action.download_16": "16x16",
  "action.dropper_16": "16x16",
  "action.edit_16": "16x16",
  "action.expand_16": "16x16",
  "action.external-link_16": "16x16",
  "action.filter_16": "16x16",
  "action.link_16": "16x16",
  "action.logout_16": "16x16",
  "action.maximize_16": "16x16",
  "action.minimize_16": "16x16",
  "action.play_16": "16x16",
  "action.pause_16": "16x16",
  "action.radio-deselected_16": "16x16",
  "action.radio-selected_16": "16x16",
  "action.reorder_16": "16x16",
  "action.table-sort-ascending_16": "16x16",
  "action.table-sort-descending_16": "16x16",
  "action.trash_16": "16x16",
  "action.copy_to_16": "16x16",
  "action.move_to_16": "16x16",
  "action.add-to_16": "16x16",
  "action.drag-handler_16": "16x16",
  "action.checkbox-indeterminate_16": "16x16",
  "action.quick-action_16": "16x16",
  "action.remove-note_16": "16x16",
  "action.add-note_16": "16x16",
  "action.revert_16": "16x16",
  "content.audio": "24x24",
  "content.code": "24x24",
  "content.color": "24x24",
  "content.file": "24x24",
  "content.file-document": "24x24",
  "content.file-graphic": "24x24",
  "content.font": "24x24",
  "content.guide": "24x24",
  "content.heading": "24x24",
  "content.kit": "24x24",
  "content.note": "24x24",
  "content.section": "24x24",
  "content.supporting-image": "24x24",
  "content.version": "24x24",
  "content.custom-colors": "24x24",
  "content.grid": "24x24",
  "content.checkered": "24x24",
  "content.portal": "24x24",
  "content.image-above": "24x24",
  "content.image-left": "24x24",
  "content.image-right": "24x24",
  "content.card-color": "24x24",
  "content.model": "24x24",
  "content.tag": "24x24",
  "content.bag": "24x24",
  "content.audio_16": "16x16",
  "content.code_16": "16x16",
  "content.color_16": "16x16",
  "content.file_16": "16x16",
  "content.file-document_16": "16x16",
  "content.file-graphic_16": "16x16",
  "content.font_16": "16x16",
  "content.guide_16": "16x16",
  "content.heading_16": "16x16",
  "content.kit_16": "16x16",
  "content.note_16": "16x16",
  "content.section_16": "16x16",
  "content.supporting-image_16": "16x16",
  "content.version_16": "16x16",
  "content.custom-colors_16": "16x16",
  "content.grid_16": "16x16",
  "content.checkered_16": "16x16",
  "content.portal_16": "16x16",
  "content.image-above_16": "16x16",
  "content.image-left_16": "16x16",
  "content.image-right_16": "16x16",
  "content.card-color_16": "16x16",
  "content.model_16": "16x16",
  "content.tag_16": "16x16",
  "content.bag_16": "16x16",
  "empty-state.assets": "24x24",
  "empty-state.supporting": "24x24",
  "info.building": "24x24",
  "info.check-circle": "24x24",
  "info.checkmark": "24x24",
  "info.cloud-download": "24x24",
  "info.code-android": "24x24",
  "info.code-apple": "24x24",
  "info.code-web": "24x24",
  "info.component": "24x24",
  "info.error": "24x24",
  "info.figma": "24x24",
  "info.frame": "24x24",
  "info.globe": "24x24",
  "info.globe-lock": "24x24",
  "info.group": "24x24",
  "info.history": "24x24",
  "info.info": "24x24",
  "info.lock-closed": "24x24",
  "info.lock-open": "24x24",
  "info.sketch": "24x24",
  "info.spinner": "24x24",
  "info.star": "24x24",
  "info.star-filled": "24x24",
  "info.upload": "24x24",
  "info.warning": "24x24",
  "info.help": "24x24",
  "info.file-meta": "24x24",
  "info.block-size": "24x24",
  "info.can-download": "24x24",
  "info.building_16": "16x16",
  "info.check-circle_16": "16x16",
  "info.checkmark_16": "16x16",
  "info.cloud-download_16": "16x16",
  "info.code-android_16": "16x16",
  "info.code-apple_16": "16x16",
  "info.code-web_16": "16x16",
  "info.component_16": "16x16",
  "info.error_16": "16x16",
  "info.figma_16": "16x16",
  "info.frame_16": "16x16",
  "info.globe_16": "16x16",
  "info.globe-lock_16": "16x16",
  "info.group_16": "16x16",
  "info.history_16": "16x16",
  "info.info_16": "16x16",
  "info.lock-closed_16": "16x16",
  "info.lock-open_16": "16x16",
  "info.sketch_16": "16x16",
  "info.spinner_16": "16x16",
  "info.star_16": "16x16",
  "info.star-filled_16": "16x16",
  "info.upload_16": "16x16",
  "info.warning_16": "16x16",
  "info.help_16": "16x16",
  "info.file-meta_16": "16x16",
  "info.block-size_16": "16x16",
  "info.can-download_16": "16x16",
  "logo.full": "75x35",
  "logo.mark": "24x24",
  "logo.mark_16": "16x16",
  "marketing.asset-library": "24x24",
  "marketing.design-system": "24x24",
  "marketing.distribution": "24x24",
  "marketing.security": "24x24",
  "marketing.storage": "24x24",
  "marketing.style-guide": "24x24",
  "marketing.support": "24x24",
  "marketing.terms": "24x24",
  "marketing.usage": "24x24",
  "marketing.asset-library_16": "16x16",
  "marketing.design-system_16": "16x16",
  "marketing.distribution_16": "16x16",
  "marketing.security_16": "16x16",
  "marketing.storage_16": "16x16",
  "marketing.style-guide_16": "16x16",
  "marketing.support_16": "16x16",
  "marketing.terms_16": "16x16",
  "marketing.usage_16": "16x16",
  "navigation.chart": "24x24",
  "navigation.chevron-down": "24x24",
  "navigation.chevron-left": "24x24",
  "navigation.chevron-right": "24x24",
  "navigation.chevron-up": "24x24",
  "navigation.credit-card": "24x24",
  "navigation.kit-menu": "24x24",
  "navigation.layout-detailed": "24x24",
  "navigation.layout-simple": "24x24",
  "navigation.mail": "24x24",
  "navigation.menu": "24x24",
  "navigation.overflow": "24x24",
  "navigation.privacy": "24x24",
  "navigation.search": "24x24",
  "navigation.settings": "24x24",
  "navigation.user": "24x24",
  "navigation.user-group": "24x24",
  "navigation.arrow-right": "24x24",
  "navigation.nav-down": "24x24",
  "navigation.nav-up": "24x24",
  "navigation.table": "24x24",
  "navigation.sidebar": "24x24",
  "navigation.chart_16": "16x16",
  "navigation.chevron-down_16": "16x16",
  "navigation.chevron-left_16": "16x16",
  "navigation.chevron-right_16": "16x16",
  "navigation.chevron-up_16": "16x16",
  "navigation.credit-card_16": "16x16",
  "navigation.kit-menu_16": "16x16",
  "navigation.layout-detailed_16": "16x16",
  "navigation.layout-simple_16": "16x16",
  "navigation.mail_16": "16x16",
  "navigation.menu_16": "16x16",
  "navigation.overflow_16": "16x16",
  "navigation.privacy_16": "16x16",
  "navigation.search_16": "16x16",
  "navigation.settings_16": "16x16",
  "navigation.user_16": "16x16",
  "navigation.user-group_16": "16x16",
  "navigation.arrow-right_16": "16x16",
  "navigation.nav-down_16": "16x16",
  "navigation.nav-up_16": "16x16",
  "navigation.table_16": "16x16",
  "navigation.sidebar_16": "16x16",
  "social.facebook": "24x24",
  "social.instagram": "24x24",
  "social.linkedin": "24x24",
  "social.facebook_16": "16x16",
  "social.instagram_16": "16x16",
  "social.linkedin_16": "16x16",
  "integrations.google-drive": "24x24",
  "integrations.dropbox": "24x24",
  "integrations.google-signin": "24x24",
  "integrations.figma": "24x24",
  "integrations.google-drive_16": "16x16",
  "integrations.dropbox_16": "16x16",
  "integrations.google-signin_16": "16x16",
  "integrations.figma_16": "16x16",
  "editor.bold": "24x24",
  "editor.bucket": "24x24",
  "editor.code": "24x24",
  "editor.italic": "24x24",
  "editor.line": "24x24",
  "editor.link": "24x24",
  "editor.ordered-list": "24x24",
  "editor.quote": "24x24",
  "editor.strike": "24x24",
  "editor.underline": "24x24",
  "editor.unordered-list": "24x24",
  "editor.text-color": "24x24",
  "editor.highlight": "24x24",
  "editor.bold_16": "16x16",
  "editor.bucket_16": "16x16",
  "editor.code_16": "16x16",
  "editor.italic_16": "16x16",
  "editor.line_16": "16x16",
  "editor.link_16": "16x16",
  "editor.ordered-list_16": "16x16",
  "editor.quote_16": "16x16",
  "editor.strike_16": "16x16",
  "editor.underline_16": "16x16",
  "editor.unordered-list_16": "16x16",
  "editor.highlight_16": "16x16",
  "editor.text-color_16": "16x16",
} as Record<string, string>;
